// extracted by mini-css-extract-plugin
export var label = "_ey-2";
export var slideContainer = "_ey-0";
export var slider = "_ey-1";